export default {
  forgot_password_confirm: {
    title: 'Restablecer contraseña',
    required_code: 'Se requiere un código',
    required_password: 'Contraseña requerida',
    max_length_16: 'La contraseña debe tener entre 8-16 caracteres',
    // no_blank: "",
    no_password_match: 'La contraseña no coincide',
    reset_password: 'Restablecer contraseña',
    caution: 'No cierres todavía esta ventana ',
    double_check_text: '@:login.double_check_text',
    password_reset_text: 'Se envió un correo electrónico a la dirección de correo electrónico. Ingresa a continuación el código de verificación enviado a su correo electrónico.',
    verification_code: 'Código de verificación',
    mail_send_code: 'Código enviado en correo electrónico',
    password: 'Contraseña',
    new_password: 'Nueva contraseña',
    password_display: 'Mostrar contraseña',
    password_no_display: 'Ocultar contraseña',
    password_check: 'Confirmar contraseña',
    submit: 'Confirmar',
  },
}
